import { render, staticRenderFns } from "./CompaniesComp.vue?vue&type=template&id=5386154d&scoped=true&"
import script from "./CompaniesComp.vue?vue&type=script&lang=js&"
export * from "./CompaniesComp.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/companiesFDV.scss?vue&type=style&index=0&id=5386154d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386154d",
  null
  
)

export default component.exports